'use strict';

/* globals config, socket, app, $ */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	'translator',
], function (Vue, translator) {
	var internals = {};

	internals.getBoardId = function () {
		return parseInt($('#board').attr('data-board'), 10);
	};

	Vue.component('board-canvas', {
		data: function () {
			return {
				notes: [],
			};
		},
		mounted: function () {
			var _this = this;

			internals.loadNotes(function (boardNotes) {
				_this.notes = boardNotes;
			});

			internals.getTranslation('note-title', function (noteTitle) {
				_this.$root.$on('addNote', function (noteComponent) {
					_this.notes.push({
						boardId: internals.getBoardId(),
						type: noteComponent,
						name: noteTitle,
						content: {},
						noteId: 0,
						commentsCount: 0,
					});
				});
			});
		},
		methods: {
			removeFromBoard: function (noteId) {
				for (var index = 0; index < this.notes.length; index++) {
					if (this.notes[index].noteId === noteId) {
						this.$delete(this.notes, index);
						break;
					}
				}
			},
		},
		template: '<div class="board-container zoomViewport"><div class="ib-board ib-board-bg"><div v-for="note in notes" :key="note" is="note" :note-data="note" :remove-from-board="removeFromBoard"></div></div></div>',
	});

	internals.loadNotes = function (callback) {
		socket.emit('plugins.ideasBoard.getBoardNotes', internals.getBoardId(), function (err, boardNotes) {
			if (err) {
				return app.alertError(err.message);
			}

			callback(boardNotes);
		});
	};

	internals.getTranslation = function (toTranslate, callback) {
		translator.translate('[[ideas-board:' + toTranslate + ']]', callback);
	};
});
